import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import StepUpPanel from "../mfa/StepUpPanel";
import { mfaErr } from "../../lib/webauthn";

// Founder-only cap change: needs a fresh step-up and a reason; audited server-side. Never raised automatically.
export default function AiCapChange({ cap, status, onSaved }) {
  const [value, setValue] = useState(String(cap));
  const [reason, setReason] = useState("");
  const [stepUp, setStepUp] = useState(null);
  const [msg, setMsg] = useState({ ok: "", err: "" });
  const hasFactor = !!status && (status.passkeys.length > 0 || status.totp.status === "active");
  const token = stepUp && stepUp.until > Date.now() ? stepUp.token : null;
  const n = Number(value);
  const valid = value !== "" && n >= 0 && n <= 10000 && reason.trim().length >= 3;
  const save = async (e) => {
    e.preventDefault();
    setMsg({ ok: "", err: "" });
    try {
      const r = await api.put("/ai/limits", { cap_usd: n, reason: reason.trim() }, { headers: { "X-MFA-StepUp": token } });
      setMsg({ ok: `Limit set to $${r.data.cap_usd.toFixed(2)} per month. Recorded in the audit log.`, err: "" }); setReason(""); onSaved();
    } catch (x) { setMsg({ ok: "", err: mfaErr(x) }); }
  };
  return (
    <section className="border border-erf-borderCream rounded bg-white p-4 space-y-3" data-testid="ai-cap-change" aria-labelledby="ai-cap-title">
      <h2 id="ai-cap-title" className="font-display font-semibold">Change the monthly limit</h2>
      {msg.ok && <p role="status" className="text-sm text-green-800" data-testid="ai-cap-saved">{msg.ok}</p>}
      {msg.err && <p role="alert" className="text-sm text-red-700" data-testid="ai-cap-error">{msg.err}</p>}
      {status && !hasFactor && (
        <p className="text-sm" data-testid="ai-cap-needs-factor">Set up a passkey or authenticator app first; changing the limit needs you to confirm it's you.{" "}
          <Link to="/settings/security" className="underline inline-flex min-h-[44px] items-center" data-testid="ai-cap-setup-link">Go to Sign-in security</Link></p>
      )}
      {status && hasFactor && <StepUpPanel status={status} stepUp={stepUp} setStepUp={setStepUp} />}
      <form onSubmit={save} className="grid gap-3 sm:grid-cols-[10rem_1fr_auto] sm:items-end">
        <fieldset disabled={!token} className="contents">
          <label htmlFor="ai-cap-value" className="text-sm">Limit (USD / month)
            <input id="ai-cap-value" type="number" min={0} max={10000} step="1" value={value} onChange={(e) => setValue(e.target.value)}
              className="block mt-1 w-full min-h-[44px] rounded border border-erf-borderCream px-3" data-testid="ai-cap-value" />
          </label>
          <label htmlFor="ai-cap-reason" className="text-sm">Reason
            <input id="ai-cap-reason" value={reason} onChange={(e) => setReason(e.target.value)} maxLength={300}
              className="block mt-1 w-full min-h-[44px] rounded border border-erf-borderCream px-3" data-testid="ai-cap-reason" />
          </label>
          <Button type="submit" disabled={!token || !valid} className="min-h-[44px] bg-erf-gold text-erf-dark font-semibold" data-testid="ai-cap-save">Save limit</Button>
        </fieldset>
      </form>
    </section>
  );
}
